import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/user_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  profile_name_cont: {
    model_name: 'Profile',
    column_type: 'string',
    label_key_path: 'profile.name',
  },
  profile_phone_cont: {
    model_name: 'Profile',
    column_type: 'string',
    label_key_path: 'profile.phone',
  },
  role_eq: {
    column_type: 'enum',
    extra: {
      options: ['designer', 'pattern_maker', 'cheif_pattern_making_officier', 'merchandiser', 'salesman', 'boss', 'supplier', 'application_admin_user', 'sales_director', 'supplier_boss', 'craftsman', 'sewer', 'valuer', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    model_name: 'User',
    label_key_path: 'user.role',
  },
  role_in: {
    column_type: 'enum',
    extra: {
      options: ['designer', 'pattern_maker', 'cheif_pattern_making_officier', 'merchandiser', 'salesman', 'boss', 'supplier', 'application_admin_user', 'sales_director', 'supplier_boss', 'craftsman', 'sewer', 'valuer', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    model_name: 'User',
    label_key_path: 'user.role',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'approved', 'rejected'],
    },
    model_name: 'User',
    label_key_path: 'user.state',
  },
  company_id_eq: {
    column_type: 'belongs_to',
    label_key_path: 'user.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'User',
  },
  company: {
    column_type: 'belongs_to',
    label_key_path: 'user.company',
    extra: {
      model_name: 'Company',
      display_column: 'name',
    },
    model_name: 'User',
  },
  pattern_maker_with_product_design_id: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.patternMakerWithProductDesignId',
  },
  is_block_eq: {
    column_type: 'boolean',
    model_name: 'User',
    label_key_path: 'user.isBlock',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('User', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('User', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
